(function () {
  function activateTab(section, tab) {
    var tabs = section.querySelectorAll('[data-braidjoy-review-tabs-tab]');
    var panels = section.querySelectorAll('[data-braidjoy-review-tabs-panel]');
    var panelId = tab.getAttribute('aria-controls');

    tabs.forEach(function (item) {
      var isActive = item === tab;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      panel.hidden = panel.id !== panelId;
    });
  }

  function postLooxQuickview(button) {
    var postId = button && button.getAttribute('data-loox-review-id');

    if (!postId) {
      return;
    }

    var payload = JSON.stringify({
      type: 'quickview',
      postId: postId,
      frame: 'looxReviewsFrame',
      ref: 'inline',
      language: '',
      thumbnails: 'false',
      showOriginal: false,
      markHighlight: false
    });

    try {
      window.postMessage(payload, '*');
    } catch (error) {
      // Keep this guarded for storefront scripts that do not expose Loox listeners.
    }

    try {
      window.parent.postMessage(payload, '*');
    } catch (error) {
      // Keep this guarded for storefront scripts that do not expose Loox listeners.
    }
  }

  function hideDuplicateLooxSection(section) {
    if (!section || section.getAttribute('data-hide-duplicate-loox') !== 'true') {
      return;
    }

    var widgets = document.querySelectorAll('#looxReviews, .loox-widget, [data-loox-widget]');

    widgets.forEach(function (widget) {
      if (section.contains(widget)) {
        return;
      }

      var duplicateSection = widget.closest('.shopify-section') || widget.closest('.page-width') || widget.parentElement;

      if (duplicateSection) {
        duplicateSection.style.display = 'none';
        duplicateSection.setAttribute('aria-hidden', 'true');
        duplicateSection.setAttribute('data-braidjoy-hidden-duplicate-loox', 'true');
      }
    });
  }

  function scheduleDuplicateLooxHide(section) {
    hideDuplicateLooxSection(section);
    window.setTimeout(function () {
      hideDuplicateLooxSection(section);
    }, 500);
    window.setTimeout(function () {
      hideDuplicateLooxSection(section);
    }, 1500);
    window.setTimeout(function () {
      hideDuplicateLooxSection(section);
    }, 3000);
  }

  function initSection(section) {
    if (!section || section.dataset.braidjoyReviewTabsInitialized === 'true') {
      return;
    }

    var tabs = section.querySelectorAll('[data-braidjoy-review-tabs-tab]');

    if (!tabs.length) {
      return;
    }

    section.dataset.braidjoyReviewTabsInitialized = 'true';
    scheduleDuplicateLooxHide(section);

    section.querySelectorAll('[data-braidjoy-loox-quickview]').forEach(function (button) {
      button.addEventListener('click', function () {
        postLooxQuickview(button);
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(section, tab);
      });

      tab.addEventListener('keydown', function (event) {
        var currentTabs = Array.prototype.slice.call(section.querySelectorAll('[data-braidjoy-review-tabs-tab]'));
        var currentIndex = currentTabs.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = currentIndex + 1 >= currentTabs.length ? 0 : currentIndex + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = currentIndex - 1 < 0 ? currentTabs.length - 1 : currentIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = currentTabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        currentTabs[nextIndex].focus();
        activateTab(section, currentTabs[nextIndex]);
      });
    });

    var selectedTab = section.querySelector('[data-braidjoy-review-tabs-tab][aria-selected="true"]') || tabs[0];
    activateTab(section, selectedTab);
  }

  function initAll() {
    document.querySelectorAll('[data-braidjoy-review-tabs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('[data-braidjoy-review-tabs]'));
    document.querySelectorAll('[data-braidjoy-review-tabs]').forEach(scheduleDuplicateLooxHide);
  });
})();
